import { useEffect } from 'react';
import { Api } from 'lavva.exalushome';
import { AppStateService } from 'lavva.exalushome/build/js/Services/AppStateService';
import { AppState, IAppStateService } from 'lavva.exalushome/build/js/Services/IAppStateService';
import { useNativeFunctionsContext } from '../../../../context/native-functions';
import { useAppSuspension } from '../../../../hooks/suspension/use-app-suspension';

export const useLavvaAppState = () => {
  const { onReturnFromSuspension } = useAppSuspension();
  const { nativeCtx } = useNativeFunctionsContext();

  const initObservableLavvaAppState = () => {
    const appStateApi = Api.Get<IAppStateService>(AppStateService.ServiceName);

    appStateApi.OnAppStateChanged().Subscribe((state: AppState) => {
      switch (state) {
        case AppState.ReturnedFromSuspension: {
          onReturnFromSuspension();
          break;
        }
      }
    });
  };

  useEffect(() => {
    if (nativeCtx !== null) initObservableLavvaAppState();
  }, [nativeCtx]);
};
